module.exports = __webpack_public_path__ + "img/file.e8e2ffd7.svg";